export default "__VITE_ASSET__BuOrqiI1__"